import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-button',
  styleUrls: ['./email-button.component.less'],
  hostDirectives: [SsrMarkToUnwrapDirective],
  imports: [EmailTextComponent],
  template: `
    <div [class]="getClassNames()">
      <table class="button-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="button-content">
            <a class="button-link" [href]="href.toJSON()">
              <email-text [contents]="label" [className]="'button-anchor-text'" />
            </a>
          </td>
        </tr>
      </table>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class EmailButtonComponent {
  @Input() public href: WrappedValue<string>;
  @Input() public label: WrappedValue<string>;
  @Input() public theme:
    | 'default'
    | 'primary'
    | 'dashed'
    | 'tellent-dashed'
    | 'danger'
    | 'tellent' = 'default';
  @Input() public inline: boolean = false;

  public getClassNames() {
    return ['button', `button-${this.theme}`, this.inline ? 'button-inline' : 'button-block'];
  }
}
